import { useState } from "react";
import { faqs } from "@/mocks/films";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="常见问答"
          title="关于这份韩国伦理电影片单的疑问"
          desc="挑片之前，这些被问得最多的问题也许正好能帮到你。点击任意一条即可展开查看。"
          align="center"
        />

        <div className="mx-auto mt-8 max-w-3xl divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100/60">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                >
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center text-foreground-500 transition-transform ${
                      open ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-xl"></i>
                  </span>
                </button>
                <div className={open ? "block px-5 pb-5" : "hidden"}>
                  <p className="text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}